import { ButtonMain } from '@quero-delivery/quero-components-web';
import { faArrowRotateRight } from '@fortawesome/pro-regular-svg-icons';
import { useLocation } from 'react-router';
import { useEffect } from 'react';

import ErrorIllustration from '@/Assets/Img/Error/error-illustration.jpeg';

import styles from './styles.module.scss';

import useScreenType from '@/hooks/util/useScreenType';
import useIsFirstRender from '@/_hooks/use-is-first-render';

interface IProps {
  resetError(): void;
  fullScreen?: boolean;
}

const ErrorFallback = ({ resetError, fullScreen = false }: IProps) => {
  const isTablet = useScreenType('tablet');
  const location = useLocation();
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    if (!isFirstRender) {
      resetError();
    }
  }, [location.pathname]);

  return (
    <div
      className={`${styles.errorFallback} ${
        fullScreen ? styles.fullscreen : ''
      }`}
      role="alert"
    >
      <section className={styles.contentInfo}>
        <h1>Ocorreu uma falha inesperada por aqui! 😵‍</h1>

        <div className={styles.whatToDo}>
          <div>
            <h2>o que pode ter causado essa falha?</h2>
            <p>
              A página que você tentou acessar foi alterada, não existe ou houve
              alguma erro no Painel.
            </p>
          </div>
          <div>
            <h2>o que você pode fazer:</h2>
            <p>
              Recarregue a página e tente realizar a operação novamente. Caso o
              problema persista, entre em contato com o suporte.
            </p>
          </div>

          <ButtonMain
            onClick={resetError}
            textFirst="Recarregar a página"
            firstStrong
            icon={faArrowRotateRight}
            iconPosition="left"
          />
        </div>
      </section>

      {!isTablet && (
        <section className={styles.imageContainer}>
          <img src={ErrorIllustration} width="100%" alt="ilustração de erro" />
        </section>
      )}
    </div>
  );
};

export { ErrorFallback };
